import ConversionLogModuleConfiguration from "./ConversionLogModuleConfiguration";
import {ConversionLogController} from "./route/conversion-log.controller";
import {ConversionLogControllerName, ConversionLogServiceName} from "../utils/names/serviceNames";
import {ConversionLogService} from "./service/ConversionLogService";
import {ConversionsLogFilter} from "./component/filter/conversions-log.filter";
import {ConversionLogTable} from "./component/conversion-log-table.component/conversion-log-table.component";
import {ConversionControlsComponent} from "./component/conversion-controls.component/conversion-controls.component";
import {
    ConversionLogCsvExportComponent
} from "./component/conversion-controls.component/controls/conversion-log-export.component/conversion-log-csv-export.component";

ConversionLogModuleConfiguration.createNewModule()
    .component('conversionLogFilter', ConversionsLogFilter.instance)
    .component('conversionLogTable', ConversionLogTable.instance)
    .component('conversionLogControls', ConversionControlsComponent.instance)
    .component('conversionLogCsvExport', ConversionLogCsvExportComponent.instance)
    .controller(ConversionLogControllerName, ConversionLogController.instance)
    .service(ConversionLogServiceName, ConversionLogService.instance);